// import axios from "axios";

// export interface ApiResponse {
//   response?: any;
//   success: boolean;  // Use 'boolean' instead of 'Boolean' for type safety
//   data?: any;
//   message: any;
//   errors?: any;
// }

// const AXIOSCONFIGMETHOD = async (
//   method: 'get' | 'post' | 'put' | 'delete',
//   url: string,
//   payload?: any,
//   headers?: any
// ): Promise<ApiResponse | undefined> => {

//   try {
//     const token = 'your-authentication-token'; // Get this token from your authentication context or state
//     const config = {
//       headers: {
//         ...headers,
//         Authorization: `Bearer ${token}`,
//         // 'Content-Type': 'application/json',
//       }
//     };

//     const resp = await axios({
//       method,
//       url,
//       data: payload,
//       ...config
//     });

//     if (resp?.data?.success) {
//       return resp.data;
//     } else {
//       console.error('Request was unsuccessful:', resp.data.message);
//       console.error('Request errors:', resp.data.errors);
//       return {
//         success: false,
//         message: resp.data.message,
//         errors: resp.data.errors
//       };
//     }
//   } catch (error: any) {
//     console.error('Error response:', error?.response);

//     // Check if the error response has structured errors
//     const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred';

//     const errors = error.response?.data?.errors || [];

//     return {
//       success: false,
//       message: errorMessage,
//       errors: errors
//     }; // Return structured error response
//   }
// };

// export default AXIOSCONFIGMETHOD;

//2nd time

import axios from "axios";

const AXIOSCONFIGMETHOD = async (method, url, payload = null, headers = {}) => {
  try {
    const token = "your-authentication-token"; // Replace with dynamic token logic if needed

    const config = {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        // 'Content-Type': 'application/json',
      },
    };

    console.log(payload, "pressings");

    const resp = await axios({
      method,
      url,
      data: payload,
      ...config,
    });

    // ✅ Handle array or no 'success' field
    if (
      resp?.data &&
      (Array.isArray(resp.data) || resp.data.success === undefined)
    ) {
      return {
        success: true,
        data: resp.data,
        message: "Request successful",
      };
    }

    if (resp?.data?.success) {
      return resp.data;
    } else {
      throw {
        response: {
          data: {
            message: resp.data.message || "Request unsuccessful",
            errors: resp.data.errors || [],
          },
        },
      };
    }
  } catch (error) {
    console.error("AXIOS ERROR:", error);

    // 🚨 Throw the error so React component's catch block gets it
    throw {
      message:
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred",
      errors: error.response?.data?.errors || [],
      status: error.response?.status || 500,
    };
  }
};

export default AXIOSCONFIGMETHOD;
